import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      Icon: FaGithub,
      url: 'https://github.com/dawsonp2003',
    },
    {
      name: 'LinkedIn',
      Icon: FaLinkedin,
      url: 'https://www.linkedin.com/in/dawson-pent',
    },
    {
      name: 'Email',
      Icon: FaEnvelope,
      url: 'mailto:dawson1203@gmail.com',
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Dawson Pent</h3>
            <p className="footer-tagline">
                Software Engineer: Full-Stack, AI, and Embedded Systems
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
              </li>
              <li>
                <Link to="/projects" onClick={() => window.scrollTo(0, 0)}>Projects</Link>
              </li>
              <li>
                <Link to="/resume" onClick={() => window.scrollTo(0, 0)}>Resume</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              {socialLinks.map((link) => {
                const Icon = link.Icon;
                return (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={link.name}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Dawson Pent. All rights reserved.
          </p>
          <p className="footer-note">
            Built with <span className="accent">React</span> & <span className="accent">TypeScript</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

